const config = {
	url_api: "https://admin.metalife.com.br/api/v1/",
	url_api_v2: "https://admin.metalife.com.br/api/v2/",
	// url_api: "http://admin.metalife.local/api/v1/",
	// url_api_v2: "http://admin.metalife.local/api/v2/",
	token: "ef5e5fc652c78ea3bb4d97fca285fe998329a260",
};
export default config;
